<template>
    <div class="section-box error-box">
        <el-tabs v-model="seaType" type="card" class="customer-tabs-mg">
            <el-tab-pane v-for="(item, index) in titleCourse" :label="item.value" :name="item.key + ''" :key="index">
            </el-tab-pane>
        </el-tabs>
        <div class="customer-list">
            <div class="next-button">
                <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="small" type="success" @click="resetSearch">重置</el-button>
            </div>
        </div>

        <el-table :stripe="true" :data="tableData" style="width: 100%; margin-top: 20px" height="670" border v-loading="listLoading">
            <!-- eslint-disable  -->
            <el-table-column label="试题内容">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.squestions" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.squestions || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="试题分类">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.nquestionCategory" placeholder="请选择试题分类">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in QUESTIONS_TYPE.CLASSIFY" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.nquestionCategory == 1">课程考试</span>
                        <span v-else-if="scope.row.nquestionCategory == 2">服务安全规范</span>
                        <span v-else-if="scope.row.nquestionCategory == 3">服务能力</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="题型">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.nquestionType" placeholder="请选择题型">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.TYPES" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.nquestionTypeStr || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="反馈人">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userName" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.userName || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="反馈时间">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker 
                            size="mini" 
                            v-model="form.createTime" 
                            type="daterange" 
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" 
                            range-separator="—" 
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" 
                            style="width: 100%"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.createTime || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="反馈类型">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.type" multiple collapse-tags placeholder="请选择类型">
                            <el-option :value="1" label="题干有误"></el-option>
                            <el-option :value="2" label="答案有误"></el-option>
                            <el-option :value="3" label="其他问题"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.typeStr || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="备注">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.description" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.description || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px; overflow: hidden">
            <div style="float: right" v-show="tableData.length">
                <el-pagination 
                    @size-change="handleSizeChange" 
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum" 
                    :page-sizes="[10, 20, 50, 100, 200]" 
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" 
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import { TEST_TYPE, QUESTIONS_TYPE } from '@/config/const/common.js'
    import {
        questionBankErrorRecord,
    } from "@/service/examination";
    export default {
        components: {},
        data() {
            return {
                TEST_TYPE,
                QUESTIONS_TYPE,

                seaType: '1',
                titleCourse: [],
                listLoading: false,
                form: {
                    pageNum: 1,
                    pageSize: 10,

                    squestions: '',             // 试题内容
                    nquestionCategory: '',      // 试题分类
                    nquestionType: '',          // 试题题型
                    userName: '',               // 反馈人
                    createTime: [],             // 反馈时间
                    type: [],                   // 反馈类型
                    description: '',            // 备注
                },
                searchData: {},
                oraginForm: {},
                total: 0,

                tableData: [],
            };
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.getTitle();
        },
        methods: {
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            resetSearch() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            async getErrorRecordList() {
                this.listLoading = true;
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.squestions && delete data.squestions
                !data.nquestionCategory && delete data.nquestionCategory
                !data.nquestionType && delete data.nquestionType
                !data.userName && delete data.userName
                if (data.createTime && data.createTime.length) {
                    data.createTimeBegin = data.createTime[0] + ' 00:00:01'
                    data.createTimeEnd = data.createTime[1] + ' 23:59:59'
                }
                delete data.createTime
                data.type = data.type.join(',')
                !data.type && delete data.type
                !data.description && delete data.description
                let res = await questionBankErrorRecord(data);
                this.listLoading = false;
                if (res.Result != 1) {
                    return this.$message.error("获取失败请联系开发人员");
                }
                this.tableData = res.Data.datas;
                this.total = res.Data.total;
            },
            getTitle() {
                this.titleCourse = [{
                    key: 1,
                    value: "试题报错",
                }, ];
            },
            handleSizeChange(val) {
                if (this.listLoading) return;
                this.form.pageNum = 1
                this.form.pageSize = val
                this.searchData.pageNum = 1
                this.searchData.pageSize = val
                this.getErrorRecordList();
            },
            handleCurrentChange(val) {
                if (this.listLoading) return;
                this.form.pageNum = val
                this.searchData.pageNum = val
                this.getErrorRecordList();
            },
        },
    };
</script>
<style lang="scss">
    .customer-tabs-mg {
        .el-tabs__header {
            margin: 0 0 15px !important;
        }
    }

    .customer-list {
        position: relative;

        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }

    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;

        .el-form-item {
            margin-bottom: 0 !important;
        }

        .selected {
            color: #409eff;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }

    .linkInfo {
        cursor: pointer;

        &:hover {
            color: #409eff;
        }
    }
</style>